import React from 'react'
import cn from 'classnames'

import { ActionButton } from '../ActionButton/ActionButton'
import { TransformChange } from '../TransformChange/TransformChange'

import './OwnerFormChange.scss'

export const OwnerFormChange = ({
  lock,
  amount,
  actionResult,
  onChange,
  onSave,
  onAccept,
  onCancel,
}) => {
  return (
    <div className={cn( 'owner-form-change', { lock } )}>
      {
        onAccept
        ? (
          <div className="buttons-row">
            <ActionButton
              label="ACCEPT BID"
              green
              onClick={ onAccept }
            />
            <ActionButton
              label="CANCEL SELLING"
              yellow
              onClick={ onCancel }
            />
          </div>
        )
        : (
          <ActionButton
            label="CANCEL SELLING"
            yellow
            onClick={ onCancel }
          />
        )
      }
      <TransformChange
        label={
          document.body.offsetWidth > 500
          ? 'CHANGE PRICE'
          : 'CHANGE'
        }
        checkLabel="I AGREE TO CHANGE THE PRICE"
        actionResult={ actionResult }
        amount={ amount }
        onChange={ onChange }
        onAccept={ onSave }
      />
    </div>
  )
}